import React from 'react';
import Sidebar from './Sidebar';
import Dashboard from './Dashboard';
import Inbox from './inbox/Inbox';
import Lessons from './Lessons';
import Profile from './Profile';
import Payments from './Payments';
import StudentFileSharing from './FileSharing';
import Bookings from './Bookings';
import Recordings from './Recordings';


function StudentHome({ activeComponent }) {
    console.log(activeComponent)

  const renderComponent = () => {
    console.log(activeComponent)
    switch (activeComponent) {
      case 'Inbox':
        return <Inbox />;
      case 'Invoice':
        return <Lessons />;
      case 'Bookings':
        return <Bookings />;
      case 'Recordings':
        return <Recordings />;
      case 'FileSharing':
        return <StudentFileSharing />;
      case 'Profile':
        return <Profile />;
      case 'Payments':
        return <Payments/>;
      default:
        return <Dashboard/>;
    }
  };

  return (
    <Sidebar activeComponent={activeComponent}>
      {renderComponent()}
    </Sidebar>
  );
}

export default StudentHome;